import { render } from "./CustomElement.vue?vue&type=template&id=199554cc&scoped=true"
import script from "./CustomElement.vue?vue&type=script&lang=js"
export * from "./CustomElement.vue?vue&type=script&lang=js"

import "./CustomElement.vue?vue&type=style&index=0&id=199554cc&scoped=true&lang=scss"

import exportComponent from "/builds/oleksandr.makhovskyi/admin-template/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-199554cc"]])

export default __exports__